module.exports = __webpack_public_path__ + "img/thumbs-up.0a8686bf.svg";